import { type GridColDef } from "@mui/x-data-grid";

import { TDateISODate } from "api/common/types/datetime.types";
import { PolicyLetter } from "api/public/policies/policies.types";
import { dataGridDateGetter } from "components/MUI/DataGrid/DataGrid.utils";

import PolicyTitleCell from "./PolicyTitle.cell";

const getLatestDate = (policy: PolicyLetter): TDateISODate => {
  let latestDate = policy.policy_date;

  for (const { policy_date } of policy.addendums ?? []) {
    if (policy_date.localeCompare(latestDate) < 0) {
      latestDate = policy_date;
    }
  }

  return latestDate;
};

export const policyLettersColumns: GridColDef<PolicyLetter>[] = [
  {
    headerName: "No.",
    field: "policy_num",
    width: 100,
    valueFormatter: (value: number) => value?.toString().padStart(3, "0"),
  },
  {
    headerName: "Title",
    field: "policy_title",
    flex: 2,
    sortable: false,
    valueGetter: (value, { addendums }) => {
      if (!addendums.length) return value;

      const addendumStrings = addendums
        .map(
          ({ addendum_num, policy_title }) =>
            `addendum #${addendum_num} - ${policy_title}`,
        )
        .join(",");

      return `${value},${addendumStrings}`;
    },
    renderCell: ({ row }) => <PolicyTitleCell policy={row} />,
  },
  {
    headerName: "Date",
    field: "policy_date",
    width: 150,
    type: "date",
    valueGetter: (_, row) => dataGridDateGetter(getLatestDate(row)),
  },
];
